import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { cn, ErrorMessage } from "@hireart/component-library";
import * as CronofyElements from "cronofy-elements";
import PropTypes from "prop-types";
import { GiraffeLoader } from "hireart-components";
import { GET_CRONOFY_ELEMENT_TOKEN } from "../get-cronofy-element-token";
import { getConfig } from "../util";
import { TARGET_ID } from "./constants";
import "./slot-picker.scss";

export const SlotPicker = ({
  className = "",
  durationInMinutes,
  interviewerIds,
  sender,
  onError,
  onSlotSelected,
  timezone,
}) => {
  const [element, setElement] = useState(null);
  const {
    data = {},
    loading: isLoading,
    error,
  } = useQuery(GET_CRONOFY_ELEMENT_TOKEN, {
    variables: { subs: interviewerIds, user: sender },
  });
  const { elementToken } = data;
  const hasError = !!error;
  const options = getConfig({
    elementToken,
    interviewerIds,
    durationInMinutes,
    onError,
    onSlotSelected,
    timezone,
    targetId: TARGET_ID,
  });

  useEffect(() => {
    if (!element && elementToken) {
      setElement(CronofyElements.SlotPicker(options));
    } else if (elementToken) {
      element.update(options);
    }
  }, [element, options, elementToken]);

  return (
    <>
      {isLoading && <GiraffeLoader />}
      {hasError && (
        <ErrorMessage className="[&_a:hover:visited]:!text-blue-80 [&_a:hover]:!text-purple-60 [&_a]:!underline" />
      )}
      <div
        className={cn({ hidden: isLoading || hasError }, className)}
        id={TARGET_ID}
      />
    </>
  );
};

SlotPicker.propTypes = {
  className: PropTypes.string,
  durationInMinutes: PropTypes.number.isRequired,
  sender: PropTypes.string.isRequired,
  interviewerIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onError: PropTypes.func.isRequired,
  onSlotSelected: PropTypes.func.isRequired,
  timezone: PropTypes.string.isRequired,
};
